module.exports = __webpack_public_path__ + "img/yszc-gszc-hm.ec5470f7.png";